import { createLocalStorageState } from '~libs.ui.react';
import { createLocalStorage } from '~libs.typescript';

const CALENDAR_PREFERENCE_PREFIX = 'calendar:';

const PREFER_SCHEDULE_ONLY_VISIBLE_PREFERENCE_KEY = `${CALENDAR_PREFERENCE_PREFIX}:preferScheduleOnlyVisible`;
const PREFER_CANCELLED_VISITS_VISIBLE_PREFERENCE_KEY = `${CALENDAR_PREFERENCE_PREFIX}:preferCancelledVisitsVisible`;

export const getCalendarPreferenceStorageKeyPrefix = (): typeof CALENDAR_PREFERENCE_PREFIX =>
   CALENDAR_PREFERENCE_PREFIX;

export const useCancelledVisibilityPreferenceState = createLocalStorageState(
   createLocalStorage<boolean>(PREFER_CANCELLED_VISITS_VISIBLE_PREFERENCE_KEY)
);

export const useScheduleOnlyVisibilityPreferenceState = createLocalStorageState(
   createLocalStorage<boolean>(PREFER_SCHEDULE_ONLY_VISIBLE_PREFERENCE_KEY)
);
